import { Component } from "@angular/core";

@Component({
    selector: 'app-boton-regresar',
    templateUrl: './boton-regresar.component.html'
})

export class BotonRegresarComponent {

    public clickBackButton() {
        window.history.back();
    }

}